import { render, staticRenderFns } from "./MessageReplyListAccordion.vue?vue&type=template&id=2bbcf106&lang=pug"
import script from "./MessageReplyListAccordion.vue?vue&type=script&lang=ts"
export * from "./MessageReplyListAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports